import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { SendEmailSuccess } from './SendEmailSuccess';

import { Button, Card, Loader } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useToast from '@/hooks/useToast';
import { postRecoverEmail } from '@/services';
import { DataPostRecoverEmail, EmailsRecuperated } from '@/types';

interface dataProps {
  dataRecuperated: EmailsRecuperated[];
  dataDoc: DataPostRecoverEmail;
}

export const SendEmailRecover = ({ dataRecuperated, dataDoc }: dataProps) => {
  const { isDesktop } = useIsDesktop();
  const toast = useToast();

  const {
    data,
    mutate: postData,
    isSuccess,
    isLoading,
  } = useMutation(
    async (formData: DataPostRecoverEmail) =>
      await postRecoverEmail(2, formData),
    {
      onError: (err) => {
        const error = err as Error;
        toast.showError(error);
      },
    }
  );

  useEffect(() => {
    if (data && !data.estado) {
      toast.show(data.mensaje);
    }
  }, [data, toast]);

  const handlePostData = () => {
    postData(dataDoc);
  };

  const mainContent = (
    <div>
      <p className="text-sm lg:mt-7 break font-medium text-gdt-gray">
        Jugaste a Gran DT con el documento ingresado y el email
        {dataRecuperated.length > 1 ? (
          <ul>
            {dataRecuperated.map((e) => (
              <li key={e.idAuth0}>
                <strong>{e.emailDistorsionado}</strong>
              </li>
            ))}
          </ul>
        ) : (
          <strong>&nbsp; {dataRecuperated[0].emailDistorsionado}</strong>
        )}
      </p>
      <Button
        className="w-full mt-8 lg:mt-10 lg:max-w-xs block mx-auto"
        disabled={isSuccess || isLoading}
        id="btnPostAccess"
        type="submit"
        variant="primary"
        onClick={handlePostData}
      >
        Enviar acceso por mail
      </Button>
    </div>
  );

  if (!data?.estado) {
    return (
      <>
        {<Loader isVisible={isLoading} timeout={true} />}
        {isDesktop ? (
          <Card title="Recordar e-mail">{mainContent}</Card>
        ) : (
          mainContent
        )}
      </>
    );
  }

  return (
    <>
      {<Loader isVisible={isLoading} timeout={true} />}
      {!isDesktop && mainContent}
      <SendEmailSuccess />
    </>
  );
};
